import { ActionTypes } from "./report.actions";
import { Action } from "@ngrx/store";
import { ReportConfiguration, ReportDocument } from "./report.model";
import { ActionTypes as PlanEditorActionTypes } from "../plan-editor.actions";

export interface State {
  generating: boolean;
  updated: boolean;
  pdfPath: string;
  configuration: ReportConfiguration;
  documents: ReportDocument[];
}

export const initialState: State = {
  generating: false,
  updated: false,
  pdfPath: null,
  configuration: null,
  documents: [],
};

export function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case ActionTypes.GENERATE:
      return Object.assign({}, state, { generating: true, updated: true });

    case ActionTypes.GENERATE_SUCCESS:
      return Object.assign({}, state, {
        generating: false,
        pdfPath: action.payload,
      });

    case ActionTypes.ADD_PHOTOS_DOCUMENT_SUCCESS:
      return Object.assign({}, state, {
        documents: [...state.documents, action.payload],
      });

    case ActionTypes.ADD_DOCUMENTS_SUCCESS:
      return Object.assign({}, state, {
        documents: [...state.documents, ...action.payload],
      });

    case ActionTypes.UPDATE_DOCUMENT_SUCCESS:
      return Object.assign({}, state, {
        documents: state.documents.map((document) => {
          return document.id === action.payload.id
            ? Object.assign({}, document, action.payload)
            : document;
        }),
      });

    case ActionTypes.REMOVE_DOCUMENT_SUCCESS:
      return Object.assign({}, state, {
        documents: state.documents.filter(
          (document) => document.id !== action.payload.id,
        ),
      });

    case PlanEditorActionTypes.LOAD_SUCCESS:
      return Object.assign({}, state, {
        generating: false,
        updated: false,
        pdfPath: null,
        configuration: null,
        documents: action.payload.documents,
      });

    default:
      return state;
  }
}

export const isGenerating = (state: State) => state.generating;
export const isUpdated = (state: State) => state.updated;
export const getPdfPath = (state: State) => state.pdfPath;
export const getConfiguration = (state: State) => state.configuration;
export const getDocuments = (state: State) =>
  state.documents.sort((a, b) => {
    return a.position < b.position ? -1 : 1;
  });



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/report/report.reducer.ts